"use strict";
/*
 * Created on Wed Apr 24 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var AdtFlag_1 = require("../../core/model/AdtFlag");
/**
 * Product flag is related to {@link SupplierAgreement} validation
 *
 * @author JMt
 */
// tslint:disable:max-classes-per-file


var SupplierAgreementWarningFlag =
/*#__PURE__*/
function (_AdtFlag_1$AdtFlag) {
  _inherits(SupplierAgreementWarningFlag, _AdtFlag_1$AdtFlag);

  // tslint:disable-next-line
  function SupplierAgreementWarningFlag(infoMessage, messageVars) {
    var _this;

    _classCallCheck(this, SupplierAgreementWarningFlag);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SupplierAgreementWarningFlag).call(this));
    _this.infoMessage = infoMessage;
    _this.messageVars = messageVars;
    return _this;
  }

  _createClass(SupplierAgreementWarningFlag, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }], [{
    key: "register",
    value: function register(ctor, tag) {
      return AdtFlag_1.AdtFlag.registerBase(SupplierAgreementWarningFlag, ctor, tag);
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return AdtFlag_1.AdtFlag.deserializeBase(SupplierAgreementWarningFlag, data);
    }
  }]);

  return SupplierAgreementWarningFlag;
}(AdtFlag_1.AdtFlag);

exports.SupplierAgreementWarningFlag = SupplierAgreementWarningFlag;
SupplierAgreementWarningFlag.TAG = '__SupplierAgremeentFlag__';
/**
 * Flag indicating the product doesn't have a preferred supplier for a given GOS/warehouse
 */

var SupplierNotPreferred =
/*#__PURE__*/
function (_SupplierAgreementWar) {
  _inherits(SupplierNotPreferred, _SupplierAgreementWar);

  function SupplierNotPreferred() {
    _classCallCheck(this, SupplierNotPreferred);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierNotPreferred).apply(this, arguments));
  }

  return SupplierNotPreferred;
}(SupplierAgreementWarningFlag);

exports.SupplierNotPreferred = SupplierNotPreferred;
SupplierNotPreferred.TAG = SupplierAgreementWarningFlag.register(SupplierNotPreferred);
/**
 * Flag indicating the product doesn't have a supplier
 */

var SupplierNotFound =
/*#__PURE__*/
function (_SupplierAgreementWar2) {
  _inherits(SupplierNotFound, _SupplierAgreementWar2);

  function SupplierNotFound() {
    _classCallCheck(this, SupplierNotFound);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierNotFound).apply(this, arguments));
  }

  return SupplierNotFound;
}(SupplierAgreementWarningFlag);

exports.SupplierNotFound = SupplierNotFound;
SupplierNotFound.TAG = SupplierAgreementWarningFlag.register(SupplierNotFound);
/**
 * Flag indicating that sum of supplier splits is over or under 100%
 */

var SuppliersWrongSplitFlag =
/*#__PURE__*/
function (_SupplierAgreementWar3) {
  _inherits(SuppliersWrongSplitFlag, _SupplierAgreementWar3);

  function SuppliersWrongSplitFlag() {
    _classCallCheck(this, SuppliersWrongSplitFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(SuppliersWrongSplitFlag).apply(this, arguments));
  }

  return SuppliersWrongSplitFlag;
}(SupplierAgreementWarningFlag);

exports.SuppliersWrongSplitFlag = SuppliersWrongSplitFlag;
SuppliersWrongSplitFlag.TAG = SupplierAgreementWarningFlag.register(SuppliersWrongSplitFlag);
/**
 * Unit back discount w/o setting Unit back discount realization and Supplier for invoice
 */

var IncompleteUnitBackDiscount =
/*#__PURE__*/
function (_SupplierAgreementWar4) {
  _inherits(IncompleteUnitBackDiscount, _SupplierAgreementWar4);

  function IncompleteUnitBackDiscount() {
    _classCallCheck(this, IncompleteUnitBackDiscount);

    return _possibleConstructorReturn(this, _getPrototypeOf(IncompleteUnitBackDiscount).apply(this, arguments));
  }

  return IncompleteUnitBackDiscount;
}(SupplierAgreementWarningFlag);

exports.IncompleteUnitBackDiscount = IncompleteUnitBackDiscount;
IncompleteUnitBackDiscount.TAG = SupplierAgreementWarningFlag.register(IncompleteUnitBackDiscount);

var InvalidPromoPurchaseStartDateFlag =
/*#__PURE__*/
function (_SupplierAgreementWar5) {
  _inherits(InvalidPromoPurchaseStartDateFlag, _SupplierAgreementWar5);

  function InvalidPromoPurchaseStartDateFlag() {
    _classCallCheck(this, InvalidPromoPurchaseStartDateFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(InvalidPromoPurchaseStartDateFlag).apply(this, arguments));
  }

  return InvalidPromoPurchaseStartDateFlag;
}(SupplierAgreementWarningFlag);

exports.InvalidPromoPurchaseStartDateFlag = InvalidPromoPurchaseStartDateFlag;
InvalidPromoPurchaseStartDateFlag.TAG = SupplierAgreementWarningFlag.register(InvalidPromoPurchaseStartDateFlag);

var InvalidPromoPurchaseStartDatePreferredFlag =
/*#__PURE__*/
function (_SupplierAgreementWar6) {
  _inherits(InvalidPromoPurchaseStartDatePreferredFlag, _SupplierAgreementWar6);

  function InvalidPromoPurchaseStartDatePreferredFlag() {
    _classCallCheck(this, InvalidPromoPurchaseStartDatePreferredFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(InvalidPromoPurchaseStartDatePreferredFlag).apply(this, arguments));
  }

  return InvalidPromoPurchaseStartDatePreferredFlag;
}(SupplierAgreementWarningFlag);

exports.InvalidPromoPurchaseStartDatePreferredFlag = InvalidPromoPurchaseStartDatePreferredFlag;
InvalidPromoPurchaseStartDatePreferredFlag.TAG = SupplierAgreementWarningFlag.register(InvalidPromoPurchaseStartDatePreferredFlag);

var DatesOrFormatWithoutFilledPromoPPriceFlag =
/*#__PURE__*/
function (_SupplierAgreementWar7) {
  _inherits(DatesOrFormatWithoutFilledPromoPPriceFlag, _SupplierAgreementWar7);

  function DatesOrFormatWithoutFilledPromoPPriceFlag() {
    _classCallCheck(this, DatesOrFormatWithoutFilledPromoPPriceFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(DatesOrFormatWithoutFilledPromoPPriceFlag).apply(this, arguments));
  }

  return DatesOrFormatWithoutFilledPromoPPriceFlag;
}(SupplierAgreementWarningFlag);

exports.DatesOrFormatWithoutFilledPromoPPriceFlag = DatesOrFormatWithoutFilledPromoPPriceFlag;
DatesOrFormatWithoutFilledPromoPPriceFlag.TAG = SupplierAgreementWarningFlag.register(DatesOrFormatWithoutFilledPromoPPriceFlag);

var MissingConfirmedPurchaseForecastSMPAFlag =
/*#__PURE__*/
function (_SupplierAgreementWar8) {
  _inherits(MissingConfirmedPurchaseForecastSMPAFlag, _SupplierAgreementWar8);

  function MissingConfirmedPurchaseForecastSMPAFlag() {
    _classCallCheck(this, MissingConfirmedPurchaseForecastSMPAFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(MissingConfirmedPurchaseForecastSMPAFlag).apply(this, arguments));
  }

  return MissingConfirmedPurchaseForecastSMPAFlag;
}(SupplierAgreementWarningFlag);

exports.MissingConfirmedPurchaseForecastSMPAFlag = MissingConfirmedPurchaseForecastSMPAFlag;
MissingConfirmedPurchaseForecastSMPAFlag.TAG = SupplierAgreementWarningFlag.register(MissingConfirmedPurchaseForecastSMPAFlag);

var LeafletFeeRoundingNeeded =
/*#__PURE__*/
function (_SupplierAgreementWar9) {
  _inherits(LeafletFeeRoundingNeeded, _SupplierAgreementWar9);

  function LeafletFeeRoundingNeeded() {
    _classCallCheck(this, LeafletFeeRoundingNeeded);

    return _possibleConstructorReturn(this, _getPrototypeOf(LeafletFeeRoundingNeeded).apply(this, arguments));
  }

  return LeafletFeeRoundingNeeded;
}(SupplierAgreementWarningFlag);

exports.LeafletFeeRoundingNeeded = LeafletFeeRoundingNeeded;
LeafletFeeRoundingNeeded.TAG = LeafletFeeRoundingNeeded.register(LeafletFeeRoundingNeeded);

var SecondaryPlacementFeeRoundingNeeded =
/*#__PURE__*/
function (_SupplierAgreementWar10) {
  _inherits(SecondaryPlacementFeeRoundingNeeded, _SupplierAgreementWar10);

  function SecondaryPlacementFeeRoundingNeeded() {
    _classCallCheck(this, SecondaryPlacementFeeRoundingNeeded);

    return _possibleConstructorReturn(this, _getPrototypeOf(SecondaryPlacementFeeRoundingNeeded).apply(this, arguments));
  }

  return SecondaryPlacementFeeRoundingNeeded;
}(SupplierAgreementWarningFlag);

exports.SecondaryPlacementFeeRoundingNeeded = SecondaryPlacementFeeRoundingNeeded;
SecondaryPlacementFeeRoundingNeeded.TAG = SecondaryPlacementFeeRoundingNeeded.register(SecondaryPlacementFeeRoundingNeeded);

var PromoPurchasePriceEmpty =
/*#__PURE__*/
function (_SupplierAgreementWar11) {
  _inherits(PromoPurchasePriceEmpty, _SupplierAgreementWar11);

  function PromoPurchasePriceEmpty() {
    _classCallCheck(this, PromoPurchasePriceEmpty);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromoPurchasePriceEmpty).apply(this, arguments));
  }

  return PromoPurchasePriceEmpty;
}(SupplierAgreementWarningFlag);

exports.PromoPurchasePriceEmpty = PromoPurchasePriceEmpty;
PromoPurchasePriceEmpty.TAG = PromoPurchasePriceEmpty.register(PromoPurchasePriceEmpty);

var ValueMissingPromoPurchasePriceFlag =
/*#__PURE__*/
function (_SupplierAgreementWar12) {
  _inherits(ValueMissingPromoPurchasePriceFlag, _SupplierAgreementWar12);

  function ValueMissingPromoPurchasePriceFlag() {
    _classCallCheck(this, ValueMissingPromoPurchasePriceFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValueMissingPromoPurchasePriceFlag).apply(this, arguments));
  }

  return ValueMissingPromoPurchasePriceFlag;
}(SupplierAgreementWarningFlag);

exports.ValueMissingPromoPurchasePriceFlag = ValueMissingPromoPurchasePriceFlag;
ValueMissingPromoPurchasePriceFlag.TAG = ValueMissingPromoPurchasePriceFlag.register(ValueMissingPromoPurchasePriceFlag);
/**
 * Groups of validation flags for generic use cases.
 */

var SupplierAgreementWarningFlagGroups = function SupplierAgreementWarningFlagGroups() {
  _classCallCheck(this, SupplierAgreementWarningFlagGroups);
};

exports.SupplierAgreementWarningFlagGroups = SupplierAgreementWarningFlagGroups;
/**
 * List of validation flags for which error should be thrown during session save.
 */

SupplierAgreementWarningFlagGroups.FLAGS_REJECTING_SAVE_SESSION = immutable_1.Set.of(DatesOrFormatWithoutFilledPromoPPriceFlag, IncompleteUnitBackDiscount, InvalidPromoPurchaseStartDateFlag, InvalidPromoPurchaseStartDatePreferredFlag, MissingConfirmedPurchaseForecastSMPAFlag, LeafletFeeRoundingNeeded, SecondaryPlacementFeeRoundingNeeded, PromoPurchasePriceEmpty, ValueMissingPromoPurchasePriceFlag);